import Marker from './Marker'

/**
 * A map marker with popup representing a POI.
 */
export default class Cluster extends Marker {

    /**
     * @param {Object} lngLat Position of the marker
     * @param {number} numPoints Number of points combined in this cluster
     * @param {() => void} onClick Simple click handler
     */
    constructor(lngLat, numPoints, onClick) {
        const element = document.createElement('div')
        element.className = 'map-cluster'
        element.textContent = '' + numPoints
        element.addEventListener('click', onClick)

        super(lngLat, element)
    }

}
